import request from "./client";

export type InspectionItemRecord = {
  id: number;
  item_name: string;
  display_order: number;
};

export type RoomInspectionRecord = {
  id: number;
  room_id: number;
  inspection_date: string;
  inspected_by?: number | null;
  result: "pass" | "fail" | "attention_required";
  comments?: string | null;
  created_at?: string;
};

export type KitchenInspectionRecord = {
  id: number;
  property_id: number;
  inspection_date: string;
  inspected_by?: number | null;
  result: "pass" | "fail" | "attention_required";
  comments?: string | null;
  created_at?: string;
};

export type LaundryInspectionRecord = {
  id: number;
  property_id: number;
  inspection_date: string;
  inspected_by?: number | null;
  result: "pass" | "fail" | "attention_required";
  comments?: string | null;
  created_at?: string;
};

export async function getRoomInspections() {
  return request<RoomInspectionRecord[]>("/api/room-inspections");
}

export async function getKitchenInspections() {
  return request<KitchenInspectionRecord[]>("/api/kitchen-inspections");
}

export async function getLaundryInspections() {
  return request<LaundryInspectionRecord[]>("/api/laundry-inspections");
}

export async function getRoomInspectionItems() {
  return request<InspectionItemRecord[]>("/api/room-inspection-items");
}

export async function getKitchenInspectionItems() {
  return request<InspectionItemRecord[]>("/api/kitchen-inspection-items");
}

export async function getLaundryInspectionItems() {
  return request<InspectionItemRecord[]>("/api/laundry-inspection-items");
}

export async function createRoomInspection(payload: Record<string, unknown>) {
  return request<RoomInspectionRecord>("/api/room-inspections", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function createKitchenInspection(
  payload: Record<string, unknown>,
) {
  return request<KitchenInspectionRecord>("/api/kitchen-inspections", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function createLaundryInspection(
  payload: Record<string, unknown>,
) {
  return request<LaundryInspectionRecord>("/api/laundry-inspections", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}
